import React from 'react';

import { UserRead } from '@headway/api/models/UserRead';
import { CircularMenuButton } from '@headway/helix/alpha/Menu';
import { Avatar } from '@headway/helix/Avatar';
import { IconUser } from '@headway/helix/icons/User';
import { Dialog, Popover, PopoverTrigger } from '@headway/helix/Popover';
import { theme } from '@headway/helix/theme';
import { formatPatientName } from '@headway/shared/utils/patient';

import AccountMenuContent from './AccountMenuContent';

interface AccountMenuProps {
  user: any;
  logout: () => void;
  stopSpoofing: () => void;
  impersonatingUser?: UserRead;
}

export const AccountMenu: React.FC<AccountMenuProps> = ({
  user,
  logout,
  stopSpoofing,
  impersonatingUser,
}) => {
  let content: React.ReactNode = formatPatientName(user, {
    firstInitial: true,
    lastInitial: true,
    initialsWithoutPeriodOrSpace: true,
  });

  if (!content) {
    content = (
      <IconUser
        variant="filled"
        fill={theme.color.foreground.secondary}
        size={16}
      />
    );
  }

  return (
    <PopoverTrigger>
      <CircularMenuButton aria-label="Open account menu">
        <Avatar size="small" aria-hidden={true}>
          {content}
        </Avatar>
      </CircularMenuButton>
      <Popover width="content" placement="bottom end" offset={8}>
        <Dialog aria-label="Account menu" id="user-menu">
          <AccountMenuContent
            user={user}
            impersonatingUser={impersonatingUser}
            logout={logout}
            stopSpoofing={stopSpoofing}
          />
        </Dialog>
      </Popover>
    </PopoverTrigger>
  );
};
